<template>
  <footer class="premium-footer">
    <div class="footer-map" aria-hidden="true"></div>
    <div class="container footer-grid">
      <section class="footer-brand">
        <router-link to="/" class="footer-logo" aria-label="AiPath home">
          <img src="../../assets/img/logo/LogoPg-smaller.webp" alt="AiPath Company Logo" />
          <span>AiPath</span>
        </router-link>
        <p>{{ $t("footer.description") }}</p>
        <router-link to="/iso" class="iso-pill">
          <img src="../../assets/img/iso/iso-logo-no-bg.png" alt="ISO Certification" />
          <span>{{ $t("footer.certification") }}</span>
        </router-link>
      </section>

      <section v-for="group in footerGroups" :key="group.id" class="footer-col">
        <button type="button" class="footer-accordion" @click="toggleGroup(group.id)" :aria-expanded="isGroupOpen(group.id)">
          <span>{{ $t(group.titleKey) }}</span>
          <span aria-hidden="true">+</span>
        </button>
        <nav :class="['footer-links', { open: isGroupOpen(group.id) }]" :aria-label="$t(group.titleKey)">
          <router-link v-for="link in group.links" :key="link.to" :to="link.to">{{ $t(link.labelKey) }}</router-link>
        </nav>
      </section>

      <section class="footer-col footer-contact">
        <button type="button" class="footer-accordion" @click="toggleGroup('contact')" :aria-expanded="isGroupOpen('contact')">
          <span>{{ $t("footer.contact") }}</span>
          <span aria-hidden="true">+</span>
        </button>
        <div :class="['footer-links', 'open-contact', { open: isGroupOpen('contact') }]">
          <a href="tel:+302113331954">+30 211 3331954</a>
          <a href="mailto:info@aipath.gr">info@aipath.gr</a>
          <span>96 Dimitriou Gounari St., Marousi, Athens</span>
        </div>
      </section>
    </div>

    <div class="container footer-bottom">
      <p>Copyright ©{{ currentYear }} AiPath. {{ $t("footer.rights") }}</p>
      <div>
        <router-link to="/gdpr">GDPR</router-link>
        <router-link to="/tos">Information Security Policy</router-link>
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  name: "HomeFooter",
  data() {
    return {
      currentYear: new Date().getFullYear(),
      openGroups: ["solutions", "company", "contact"],
      footerGroups: [
        { id: "solutions", titleKey: "footer.solutions", links: [
          { to: "/services", labelKey: "submenu_title_Development" },
          { to: "/digital-consulting", labelKey: "submenu_DigitalConsulting" },
          { to: "/web-apps", labelKey: "submenu_WebApplications" },
          { to: "/machine-learning-solutions", labelKey: "submenu_MachineLearning" },
        ] },
        { id: "company", titleKey: "footer.company", links: [
          { to: "/about", labelKey: "submenu_WhoAreWe" },
          { to: "/why-aipath", labelKey: "submenu_WhyAiPath" },
          { to: "/blog", labelKey: "menu_news" },
          { to: "/careers", labelKey: "submenu_Careers" },
        ] },
      ],
    };
  },
  methods: {
    isGroupOpen(id) {
      return this.openGroups.includes(id);
    },
    toggleGroup(id) {
      if (window.matchMedia("(min-width: 641px)").matches) return;
      this.openGroups = this.isGroupOpen(id) ? this.openGroups.filter((item) => item !== id) : [...this.openGroups, id];
    },
  },
};
</script>

<style scoped>
.premium-footer {
  position: relative;
  overflow: hidden;
  color: #dbe7ee;
  background: #061524;
  padding: 46px 0 22px;
  font-family: "Manrope", "Inter", system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif;
}
.footer-map { position: absolute; inset: 0; opacity: 0.06; background-image: url("../../assets/img/pattern/map.png"); background-size: 720px auto; background-position: center; }
.footer-grid, .footer-bottom { position: relative; z-index: 1; }
.footer-grid { display: grid; grid-template-columns: minmax(280px, 1.3fr) repeat(3, minmax(170px, .62fr)); gap: 30px; }
.footer-logo { display: inline-flex; align-items: center; gap: 12px; color: #fff; font-size: 25px; font-weight: 800; }
.footer-logo img { width: 42px; height: 42px; object-fit: contain; }
.footer-brand p { max-width: 430px; margin: 18px 0; color: rgba(255,255,255,.72); font-size: 16px; line-height: 1.62; }
.iso-pill { display: inline-flex; align-items: center; gap: 12px; padding: 9px 12px; border: 1px solid rgba(255,255,255,.14); border-radius: 12px; color: #fff; background: rgba(255,255,255,.035); font-weight: 700; }
.iso-pill img { width: 82px; height: auto; filter: brightness(0) invert(1); opacity: .9; }
.footer-col { align-content: start; }
.footer-accordion { width: 100%; min-height: 44px; display: flex; align-items: center; justify-content: space-between; padding: 0; border: 0; color: #82F2B5; background: transparent; font-size: 16px; font-weight: 800; text-align: left; }
.footer-accordion span:last-child { display: none; }
.footer-links { display: grid; gap: 10px; }
.footer-links a, .footer-links span { color: rgba(255,255,255,.76); font-size: 16px; line-height: 1.5; }
.footer-links a:hover { color: #fff; }
.footer-bottom { display: flex; align-items: center; justify-content: space-between; gap: 18px; margin-top: 34px; padding-top: 20px; border-top: 1px solid rgba(255,255,255,.12); }
.footer-bottom p, .footer-bottom a { margin: 0; color: rgba(255,255,255,.68); font-size: 14.5px; }
.footer-bottom div { display: flex; flex-wrap: wrap; gap: 16px; }
@media (max-width: 992px) { .footer-grid { grid-template-columns: 1fr 1fr; } }
@media (max-width: 640px) {
  .premium-footer { padding: 36px 0 22px; }
  .footer-grid { grid-template-columns: 1fr; gap: 16px; }
  .footer-brand { padding-bottom: 6px; }
  .footer-col { border-top: 1px solid rgba(255,255,255,.12); }
  .footer-accordion span:last-child { display: inline; transition: transform .2s ease; }
  .footer-accordion[aria-expanded="true"] span:last-child { transform: rotate(45deg); }
  .footer-links { display: none; padding: 0 0 14px; }
  .footer-links.open { display: grid; }
  .footer-bottom { align-items: flex-start; flex-direction: column; margin-top: 20px; }
}
</style>
